import React, { useContext } from 'react';

import ReactQueryProvider from '@/API/ReactQueryProvider';
import PreviousBillingForm, {
  PreviousBillingFormProps,
} from '@/components/Operator/Stripe/PreviousBillingForm';
import { AlertMessage } from '@/components/Profile/AlertMessage';
import {
  EditProfileContext,
  EditProfileProvider,
} from '@/contexts/EditProfileProvider';
import {
  BookingProvider,
  BookingProviderContext,
} from '@/contexts/BookingProfileContext';
import { AlertMessageBooking } from '@/components/Profile/AlertMessageBooking';

type Props = PreviousBillingFormProps & {
  stripeKey: string;
  clientSecretUrl: string;
  return_url: string;
  action: string;
};

const StripePayment: React.FC<Props> = ({ ...props }) => {
  const { alertMessage } = useContext(BookingProviderContext);
  return (
    <div className=' mt-10'>
      {alertMessage && (
        <div className='alert-message max-w-1440px container mt-12'>
          <AlertMessageBooking
            type={alertMessage.type}
            title={alertMessage.title}
            description={alertMessage.description}
          />
        </div>
      )}
      <PreviousBillingForm {...props} />
    </div>
  );
};

const Wrapper: React.FC = ({ children }) => {
  return <ReactQueryProvider>{children}</ReactQueryProvider>;
};

const StripePaymentWrapper: React.FC<Props> = (props) => (
  <Wrapper>
    <BookingProvider>
      <StripePayment {...props} />
    </BookingProvider>
  </Wrapper>
);

export default StripePaymentWrapper;
